/**
 * Rules of the mobile edition: no queue. One run = one life of `lifeMs`
 * (a hit only costs a coin), then the result with the call to action; a new life
 * starts with "Nochmal". The result goes into the highscore of all phones – the server
 * takes it only after MOBILE_MIN_ROUND_MS (default 70 s), keep that below `lifeMs`.
 */
export const MOBILE_RULES = {
  /** length of one life (round) */
  lifeMs: 75_000,
  /** the restart button is locked this long after the end (no accidental restart) */
  restartLockMs: 900,
} as const;
